import { Card, Grid, styled } from '../../base';

export const ResetPasswordCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    width: '520px',
    height: '520px',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
}));
export const ResetPasswordFormWrapper = styled(Grid)(() => ({
    maxWidth: '310px',
    display: 'flex',
    alignSelf: 'center',
}));
